import { Col, Row } from 'react-bootstrap';
import { TextPlaceholder } from 'shared/placeholders';

export const FuncionalidadesSelectorSkeleton = ({ rows }: { rows: number }) => (
  <>
    {Array.from({ length: rows }).map((_, index) => (
      <Row key={`funcionalidades-skeleton-placeholder-row-${index}`} className="mb-3">
        <Col md="12">
          <TextPlaceholder height={24} />
          <TextPlaceholder />
        </Col>
      </Row>
    ))}
  </>
);
